import React, { FC, memo, useCallback, useMemo } from 'react';

import { messages } from './SignupConsent.messages';
import { NoWrapLink, Root } from './SignupConsent.styles';
import { SignupConsentProps } from './SignupConsent.types';

const SignupConsent: FC<SignupConsentProps> = memo((props) => {
    const { buttonText, ...otherProps } = props;

    const stopPropagation = useCallback((event: React.SyntheticEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
    }, []);

    const termsAndPolicyParams = useMemo(
        () => ({
            buttonText,
            terms: (chunks: any) => (
                <NoWrapLink
                    href='https://www.approvalmax.com/terms'
                    target='_blank'
                    onClick={stopPropagation}
                    rel='noreferrer'
                >
                    {chunks}
                </NoWrapLink>
            ),
            policy: (chunks: any) => (
                <NoWrapLink
                    href='https://www.approvalmax.com/policy'
                    target='_blank'
                    onClick={stopPropagation}
                    rel='noreferrer'
                >
                    {chunks}
                </NoWrapLink>
            ),
        }),
        [buttonText, stopPropagation]
    );

    return <Root {...otherProps}>{messages.consentText(termsAndPolicyParams)}</Root>;
});

export default SignupConsent;
